import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "title-big t-blue uppercase text-center mr-5" }
const _hoisted_2 = { class: "form-wrapper mt-4" }
const _hoisted_3 = {
  key: 0,
  class: "text text-raleway-13 t-danger"
}
const _hoisted_4 = {
  key: 1,
  class: "text text-raleway-13 t-danger"
}
const _hoisted_5 = {
  key: 2,
  class: "text text-raleway-13 t-danger"
}
const _hoisted_6 = {
  key: 3,
  class: "text text-raleway-13 t-danger"
}
const _hoisted_7 = {
  key: 4,
  class: "text text-raleway-13 t-danger"
}
const _hoisted_8 = { class: "text text-raleway-13 t-accept" }
const _hoisted_9 = { class: "d-flex" }
const _hoisted_10 = {
  type: "submit",
  class: "btn btn-default mt-4 m-auto"
}

import { EmailNotification } from '@/components/changePassword/type'
import { IUseFetchDetailError } from '@/hook/fetch/interface'
import { ResetPasswordError, ResetType } from '../type'
import { useFetch } from '@/hook/fetch/fetch'
import router from '@/router'
import { ref, onBeforeMount, computed, watch } from 'vue';

import PasswordComponent from '@/components/password/passwordComponent.vue'
import { SeoDescription, SeoTitle } from '../../utils/seo/seo';
import { IStore } from '@/store/types/StoreType'
import { useStore } from 'vuex'


export default /*#__PURE__*/_defineComponent({
  __name: 'ResetView',
  setup(__props) {

const success = ref<EmailNotification>()
const errorFetchMessageArray = ref<string[]>([''])
const dataInput = ref<ResetType>({uidb64: '', token: '', password: '', repeat_password: ''})
const error = ref({isErrorFetch: false, errorRequred: false, errorFetchMessage: '', repeatPassword: false, commonPassword: false, isErrorFetchArray: false})

const change = (event: Event) => {
  const eventTarget = event.target as HTMLInputElement
  dataInput.value = {...dataInput.value, [eventTarget.name]: eventTarget.value}
}

const userChangePassword = async (event: Event) => {
    event.preventDefault()
    error.value.errorRequred = false
    error.value.isErrorFetch = false
    error.value.repeatPassword = false
    error.value.commonPassword = false
    error.value.isErrorFetchArray = false
    if(!dataInput.value.password && !dataInput.value.repeat_password) error.value.errorRequred = true
    if(dataInput.value.repeat_password !== dataInput.value.password) error.value.repeatPassword = true
    if(!/^(?=.*[0-9])[a-zA-Z0-9]{8,}$/.test(dataInput.value.password)) error.value.commonPassword = true

    if(!error.value.errorRequred && !error.value.repeatPassword && !error.value.commonPassword){
      const urlParams = new URLSearchParams(window.location.search)
      const { data, isError, errorMessage } = await useFetch<EmailNotification, ResetPasswordError | IUseFetchDetailError>(process.env.VUE_APP_SERVER + 'api/users/reset_password_confirm/', 'PUT', false, {...dataInput.value, uidb64: urlParams.get('uidb64') ?? '', token: urlParams.get('token') ?? ''})
        
      if(data.value && data.value.success){
        success.value = data.value
        router.replace('/auth')
      }
      if((errorMessage.value as ResetPasswordError)?.password){
        error.value.isErrorFetchArray = isError.value
        errorFetchMessageArray.value = (errorMessage.value as ResetPasswordError)?.password
      }
      if((errorMessage.value as IUseFetchDetailError)?.detail){
        error.value.isErrorFetch = isError.value
        error.value.errorFetchMessage = ((errorMessage.value as IUseFetchDetailError)?.detail as string)
      }
    }
}
const store = useStore<IStore>()
const uiLang = ref(computed<string>(() => store.getters.getUserUiLang))
onBeforeMount(() => {
    switch(uiLang.value.toUpperCase()) {
        case 'SWEDISH':
            SeoTitle('Tyre point: Ändra lösenord')
            SeoDescription('Tire Points nätbutik säljer bildäck. Vi erbjuder ett brett utbud av rabatterade däck och fälgar i Europa.')
            break
        case 'FINLAND':
            SeoTitle('Tyre point: Vaihda salasana')
            SeoDescription('Tyre Point - verkkokauppa myy autonrenkaita. Tarjoamme laajan valikoiman edullisia renkaita ja vanteita Euroopassa.')
            break
        default:
            SeoDescription('The Tyre Point online store sells car tires. We offer a wide range of discount tires and rims in Europe.')
            break
    }
})

watch(() => uiLang.value, () => {
  switch(uiLang.value.toUpperCase()) {
        case 'SWEDISH':
            SeoTitle('Tyre point: Ändra lösenord')
            SeoDescription('Tire Points nätbutik säljer bildäck. Vi erbjuder ett brett utbud av rabatterade däck och fälgar i Europa.')
            break
        case 'FINLAND':
            SeoTitle('Tyre point: Vaihda salasana')
            SeoDescription('Tyre Point - verkkokauppa myy autonrenkaita. Tarjoamme laajan valikoiman edullisia renkaita ja vanteita Euroopassa.')
            break
        default:
            SeoDescription('The Tyre Point online store sells car tires. We offer a wide range of discount tires and rims in Europe.')
            break
    }
}, {
    deep: true,
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("form", {
    onSubmit: userChangePassword,
    class: "form"
  }, [
    _createElementVNode("h1", _hoisted_1, _toDisplayString(_ctx.$tc("reset_password")) + "?", 1),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(PasswordComponent, {
        error: error.value.errorRequred,
        change: change,
        name: 'password'
      }, null, 8, ["error"]),
      _createVNode(PasswordComponent, {
        error: error.value.repeatPassword,
        change: change,
        name: 'repeat_password'
      }, null, 8, ["error"]),
      (error.value.errorRequred)
        ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(_ctx.$tc('error_logins')), 1))
        : _createCommentVNode("", true),
      (error.value.commonPassword)
        ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(_ctx.$tc('common_password')), 1))
        : _createCommentVNode("", true),
      (error.value.isErrorFetchArray)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(errorFetchMessageArray.value, (message) => {
              return (_openBlock(), _createElementBlock("p", {
                key: message,
                class: "text text-raleway-13 t-danger"
              }, _toDisplayString(message), 1))
            }), 128))
          ]))
        : _createCommentVNode("", true),
      (error.value.isErrorFetch)
        ? (_openBlock(), _createElementBlock("p", _hoisted_6, _toDisplayString(_ctx.$tc(error.value.errorFetchMessage)), 1))
        : _createCommentVNode("", true),
      (error.value.repeatPassword)
        ? (_openBlock(), _createElementBlock("p", _hoisted_7, _toDisplayString(_ctx.$tc('repeat_password')), 1))
        : _createCommentVNode("", true),
      _createElementVNode("p", _hoisted_8, _toDisplayString(success.value?.success), 1),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("button", _hoisted_10, _toDisplayString(_ctx.$tc('save_password')), 1)
      ])
    ])
  ], 32))
}
}

})